import { render, staticRenderFns } from "./role_model.vue?vue&type=template&id=6970b7d4&scoped=true&"
import script from "./role_model.vue?vue&type=script&lang=js&"
export * from "./role_model.vue?vue&type=script&lang=js&"
import style0 from "./role_model.vue?vue&type=style&index=0&id=6970b7d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6970b7d4",
  null
  
)

export default component.exports